import Plus from "src/design-system/icons/Plus.svg?react";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { hashChange } from "src/utils/location/hashChange";
import { useTypedLocation } from "src/utils/hooks/useTypedLocation";
import { useAnalyticsPageView } from "src/utils/hooks/useAnalyticsPageView";
import useSearch from "src/utils/hooks/useSearch";
import useUser from "src/utils/hooks/useUser";
import { navigateToNewStateHash } from "src/utils/location/navigateToNewStateHash";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { Button } from "src/design-system/components/Button/Button";
import { TripList } from "../MyTrips/TripList";
import messages from "./SavedTripsScreen.messages";

export function SavedTripsScreen() {
  const intl = useIntl();
  const location = useTypedLocation();
  const [numVisibleTrips, setNumVisibleTrips] = useState(5);
  const { user } = useUser();
  const isUserLoggedIn = !!user?.id;
  const navigate = useNavigate();

  const { searchResponse } = useSearch();
  useAnalyticsPageView(
    {
      pagePath: location.pathname + location.search + location.hash,
      pageLocation: window.location.href,
    },
    searchResponse,
    "SavedTrips",
    undefined,
  );

  useEffect(() => {
    if (!isUserLoggedIn) {
      navigateToNewStateHash(
        navigate,
        { highlightedTab: "trips" },
        "#trips/create",
        {
          ...location,
        },
      );
    }
  }, [isUserLoggedIn, location, navigate]);

  return (
    <div className="relative min-h-screen w-full bg-surface-secondary px-4 pt-6 pb-4">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-heading-xl">
          {intl.formatMessage(messages.savedTrips)}
        </h1>
        <Button
          variant="secondary"
          onClick={() => {
            navigate(hashChange("#trips/create/", location));
            sendAnalyticsInteractionEvent({
              category: "SavedTrips",
              action: "Click:NewTrip",
            });
          }}
        >
          <Plus className="h-4 w-4" />
          <span className="mt-0.5">
            {intl.formatMessage(messages.newButton)}
          </span>
        </Button>
      </div>

      <TripList
        numVisibleTrips={numVisibleTrips}
        setNumVisibleTrips={setNumVisibleTrips}
        onSetTrip={() => {
          sendAnalyticsInteractionEvent({
            category: "SavedTrips",
            action: "Click:SelectTrip",
          });
        }}
        onDeleteTrip={() => {
          sendAnalyticsInteractionEvent({
            category: "SavedTrips",
            action: "Click:DeleteTrip",
          });
        }}
        isFullScreen
      />
    </div>
  );
}
